<template>
    <t-modal v-model="isVisible" @closed="onModalClosed">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <form @submit.prevent="onSubmit">
                <span>
                    <h2>Enter an EMail address or Phone Number</h2>
                </span>
                <div>
                    <ValidationProvider rules="required|emailorphone" v-slot="v">
                            <input
                                id="contact-info"
                                name="via"
                                type="text"
                                class="input-field w-full"
                                required
                                v-model="via"
                            />
                            <span class="text-red-500 text-hint">{{ v.errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="flex justify-between pl-4 mt-3">
                    <div class="flex items-center">
                        <div
                            v-if="isSaving"
                            style="border-top-color: transparent"
                            class="w-8 h-8 border-4 mx-5 my-5 border-blue-400 border-solid rounded-full animate-spin"
                        ></div>
                        <button
                            class="primary-btn px-14"
                            type="submit"
                            :disabled="invalid"
                        >
                            Send
                        </button>
                    </div>
                </div>
            </form>
        </ValidationObserver>
        <t-alert variant="danger" :show="showError" class="mt-3">
            {{ errorMessage }}
        </t-alert>
    </t-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";

extend('emailorphone', value => {
    function checkphone(value) {
        let stripped = value.replaceAll( /-.()]/g, '');
        return /[0-9]/.test( stripped) && stripped.length == 10;
    }
    function checkemail( value) {
        return /^[-A-Za-z0-9.+_]+@[-A-Za-z0-9.]+$/.test( value);
    }
    return checkphone( value) || checkemail( value);
});

export default {
    props: [
        "modalVisible",
        "userId",
        "sharedUser",
    ],
    data() {
        return {
//            validationErrors: this.serverErrors,
            isSaving: false,
            isVisible: this.modalVisible,
            showError: false,
            errorMessage: "",
            generateErr: false,
            via: "",
        };
    },
    watch: {
        modalVisible() {
            if (this.isVisible !== this.modalVisible) {
                this.isVisible = this.modalVisible;
            }
        },
    },
    methods: {
        onModalClosed() {
            this.showError = false;
            this.errorMessage = "";
            this.$emit("modalHidden", true);
        },
        async onSubmit() {
            this.isSaving = true;
            if (!this.isStoreFront) {
                const isValid = await this.$refs.observer.validate();
                const formData = new FormData();
                formData.append("via", this.via);
                axios
                    .post(
                        "/api/user/" + this.sharedUser.id + "/shareUser",
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    )
                    .then((response) => {
                        if (response.data.success) {
                            this.isSaving = false;
                            this.content = "";
                            this.showError = false;
                            this.errorMessage = "";
                            this.isVisible = false;
                        }
                    })
                    .catch((error) => {
                        this.isSaving = false;
                        this.showError = true;
                        this.errorMessage = "server error";
                    });
            } else {
                setTimeout(() => {
                    this.isSaving = false;
                    this.isVisible = false;
                }, 2000);
            }
        },
    },

//    updated() {
//    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
};
</script>

